<template>
    <div class="content">
        <div v-if="this.$route.query.isApp == 1">
            <div v-if="!isLoading && linkType !== 3" class="contract-header">
                <div><i @click.stop="goBack" class="iconfont icon-xiangyou" :class="[isDirection ? '' : 'mirrorRotateLevel']"></i></div>
            </div>
            <div v-if="this.$route.query.isBanner == 0 && !isLoading" class="contract-header">
                <div><i @click.stop="goBack" class="iconfont icon-xiangyou" :class="[isDirection ? '' : 'mirrorRotateLevel']"></i></div>
            </div>
        </div>
        <div class="newBg">
            <InCompleteSiteHead v-if="this.$route.query.isApp != 1" class="InCompleteSiteHead" />
            <div class="bg">
                <div class="h5Title">
                    <div class="titleHeight"></div>
                    <div class="title">
                        <!-- SuperEx 兩週年 -->
                        <span>{{$t('10000004')}}</span>
                    </div>
                    <div class="titleTest">
                        <div class="titleTest-test">
                            <!-- 合約慶典賽 -->
                            <p>{{$t('10000005')}}</p>
                        </div>
                    </div>
                    <div class="buttonModule">
                        <div class="buttonModule-buttons">
                            <div :class="changeApplication" @click="goApplication">
                                <!-- 报名 -->
                                {{textVar}}
                            </div>
                            <div class="share" @click="goShareUrl">
                                <!-- 分享 -->
                                {{$t('300342')}}
                            </div>
                        </div>
                    </div>
                    <div class="timeModule">
                        <div class="timeModule-main">
                            <christmasCountDown :end-time="resultObj.endTime" type="2"></christmasCountDown>
                        </div>
                        <div v-if="resultObj.startTime && resultObj.endTime" class="timeModule-time">
                            {{$t('300142')}}:&nbsp;&nbsp;&nbsp;&nbsp;{{formatTimestamp(resultObj.startTime)}} ~ {{formatTimestamp(resultObj.endTime)}}
                        </div>
                        <div v-else class="timeModule-time">
                            {{$t('300142')}}: &nbsp;&nbsp;&nbsp;&nbsp;-- ~ --
                        </div>
                    </div>
                </div>
            </div>
            <div class="leekBar">
                <div class="leekBar-main">
                    <div style="margin:0 auto">
                        <div class="leekBar-main-guys">
                            <div class="man">
                                <!-- 參賽人數 -->
                                <div>{{$t('9000004')}}</div>
                                <div>{{mathGuys}}</div>
                            </div>
                            <div class="line">

                            </div>
                            <div class="money">
                                <!-- 已解锁奖池（USDT） -->
                                <div>{{$t('9000005')}}</div>
                                <div>{{moneyPond}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="leekBar-main-pro">
                        <div class="progressBar">
                            <transition name="progress-fade">
                                <div class="barRow" ref="barRow">
                                    <!-- <div class="rate-of-progress" v-if="playGuys" ref="progress" :style="{ width:progressWidth }"> -->
                                    <div class="rate-of-progress" v-if="playGuys" ref="progress" :style="{ height:progressWidth }">

                                        <div class="progress-img" ref="mask" :style="{ height:progressWidth,animationDuration:duration}">
                                        </div>
                                        <div class="progress-color"></div>
                                    </div>
                                    <div class="rate-of-progress" v-if="!playGuys">
                                        <div class="progress-img"></div>
                                        <div class="progress-color"></div>
                                    </div>
                                    <div class="leveIcon">
                                        <!-- 100 -> Y轴  22.125  相对barRow的坐标 -->
                                        <!-- top: 6.25%; -->
                                        <img class="blackIcon leveIcon-one" :src="getImage(fireImageRelativeY,6.25)">
                                        <!-- 500 -> y轴  109 -->
                                        <!-- top: 31.25%; -->
                                        <img class="blackIcon leveIcon-two" :src="getImage(fireImageRelativeY,31.25)">
                                        <!-- 1000 -> y轴  199.96875 -->
                                        <!-- top: 62.5% -->
                                        <img class="blackIcon leveIcon-three" :src="getImage(fireImageRelativeY,62.5)">
                                        <!-- 1500 -> y轴  287.65625 -->
                                        <!-- top: 93.75%; -->
                                        <img class="blackIcon leveIcon-four" :src="getImage(fireImageRelativeY,93.75)">
                                    </div>
                                    <img class="fireImage" ref="fireImage" src="@/assets/images/yuanyuanCH.png" :style="{ top:progressWidth }" alt />
                                </div>
                            </transition>
                        </div>
                        <div class="proMain">
                            <div class="proMain-item">
                                <div class="proMain-item-money">
                                    2,500 USDT
                                </div>
                                <div class="proMain-item-icon">
                                    <div class="proMainNums">＞100</div>
                                    <img class="chGuys" src="../assets/images/chGuys.png">
                                </div>
                            </div>
                            <div class="proMain-item top1">
                                <div class="proMain-item-money">
                                    5,000 USDT
                                </div>
                                <div class="proMain-item-icon">
                                    <div class="proMainNums">＞500</div>
                                    <img class="chGuys" src="../assets/images/chGuys.png">
                                </div>
                            </div>
                            <div class="proMain-item top2">
                                <div class="proMain-item-money">
                                    7,500 USDT
                                </div>
                                <div class="proMain-item-icon">
                                    <div class="proMainNums">＞1000</div>
                                    <img class="chGuys" src="../assets/images/chGuys.png">
                                </div>
                            </div>
                            <div class="proMain-item top3">
                                <div class="proMain-item-money">
                                    10,000 USDT
                                </div>
                                <div class="proMain-item-icon">
                                    <div class="proMainNums">＞1500</div>
                                    <img class="chGuys" src="../assets/images/chGuys.png">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="toSwitch">
                <!-- tabs -->
                <div class="tabs">
                    <!-- 交易量排名资格赛 -->
                    <div class="tabs" @click="tabChange('one',subIdOne)" :class="{activeTab: activeName == 'one'}">
                        <span>{{$t('9000006')}}</span>
                        <div class="borderBottom"></div>
                    </div>
                    <!-- 盈利率排名资格赛 -->
                    <div class="tabs" @click="tabChange('two',subIdTwo)" :class="{activeTab: activeName == 'two'}">
                        <span>{{$t('9000007')}}</span>
                        <div class="borderBottom"></div>
                    </div>
                    <!-- 盈利额排名资格赛 -->
                    <div class="tabs" @click="tabChange('three',subIdThree)" :class="{activeTab: activeName == 'three'}">
                        <span>{{$t('9000008')}}</span>
                        <div class="borderBottom"></div>
                    </div>
                </div>
                <!-- tables -->
                <div class="tables">
                    <div class="tables-one" v-if="activeName == 'one'">
                        <!-- 交易量排名资格赛 table -->
                        <div class="tablesTitle">
                            <div class="tablesTitle-test1">
                                <!-- 交易量排名赛，解锁最高 <span>{{moneyPond}}</span> USDT 奖金池 -->
                                <!-- <p v-html="$t('9000009', { moneyPond: this.moneyPond })"></p> -->
                                <p v-html="$t('10000006')"></p>
                            </div>
                            <div class="tablesTitle-test2">
                                <!-- 根据参赛人数解锁对应奖池，参赛人数越多解锁奖池越大，最高20,000U奖金池 -->
                                {{$t('10000003')}}
                            </div>
                        </div>
                        <div class="tablesPic">
                            <!-- <img src="../assets/images/yuanMoney.png"> -->
                            <div class="tablesPic-test1">
                                <!-- 奖池金额 -->
                                {{$t('9000011')}}
                                <br>
                                (USDT)
                            </div>
                            <div class="tablesPic-test2">
                                {{moneyPond}}
                            </div>
                        </div>
                        <div class="rankList">
                            <div class="rankList-title">
                                <!-- 9000029 活動交易額排名 -->
                                <span>{{$t('9000029')}}</span>
                            </div>
                            <!--              <div class="rankList-test">
                  &lt;!&ndash; 活动期间每天 8pm(UTC+8)更新 &ndash;&gt;
                  {{$t('9000012')}}
                </div>-->
                            <div class="rankList-pic">
                                <div class="rankListPicMain" v-if="subMsgList1.length > 0">
                                    <div v-if="subMsgList1 && subMsgList1.length >= 1" class="rankOne">
                                        <span>{{subMsgList1[0].userId}}</span>
                                        <!-- <span>linebacker</span> -->
                                    </div>
                                    <div v-if="subMsgList1 && subMsgList1.length >= 2" class="rankTwo">
                                        <span>{{subMsgList1[1].userId}}</span>
                                        <!-- <span>linebacker</span> -->
                                    </div>
                                    <div v-if="subMsgList1 && subMsgList1.length >= 3" class="rankThree">
                                        <span>{{subMsgList1[2].userId}}</span>
                                        <!-- <span>linebacker</span> -->
                                    </div>
                                    <img v-if="!isDirection" src="../assets/images/rankBg.png">
                                    <img v-else src="../assets/images/rankBgFa.png">
                                    <div class="moneyOne">
                                        <!-- 预估奖励 -->
                                        <span>{{$t('9000013')}}(USDT)</span>
                                        <span v-if="subMsgList1[0]">{{subMsgList1[0].rewardEstimate.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                    </div>
                                    <div class="moneyTwo">
                                        <span>{{$t('9000013')}}(USDT)</span>
                                        <span v-if="subMsgList1[1]">{{subMsgList1[1].rewardEstimate.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                    </div>
                                    <div class="moneyThree">
                                        <span>{{$t('9000013')}}(USDT)</span>
                                        <span v-if="subMsgList1[2]">{{subMsgList1[2].rewardEstimate.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="rankList-list" v-show="subMsgList1.length !== 0">
                                <div class="rankList-list-titleBg">
                                    <div>
                                        <!-- 排名 -->
                                        <span class="titleBg1">{{$t('300084')}}</span>
                                    </div>
                                    <div>
                                        <span class="titleBg2">UID</span>
                                    </div>
                                    <div>
                                        <!-- 期间累计合约交易金额 -->
                                        <span class="titleBg3">{{$t('9000014')}}</span>
                                    </div>
                                    <div>
                                        <!-- 奖励预估 -->
                                        <span class="titleBg4">{{$t('9000013')}}</span>
                                    </div>
                                </div>
                            </div>
                            <!-- 循环 -->
                            <div class="rankScrollbar" style="max-height: 640px;overflow-y: auto;">
                                <div class="rankList-listMain" v-for="item in subMsgList1" :key="item.index">
                                    <div class="listMainIcon">
                                        <div class="listMainIcon-img" :style="{ 'background-image': getBackgroundImage(item.ranked) }">
                                            <span>{{item.ranked}}</span>
                                        </div>
                                    </div>
                                    <div class="listMainTest1">
                                        <span>{{item.userId}}</span>
                                    </div>
                                    <div class="listMainTest2">
                                        <span>{{item.tradeProfit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} USDT</span>
                                    </div>
                                    <div class="listMainTest3">
                                        <span>{{item.rewardEstimate.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} USDT</span>
                                    </div>
                                </div>
                            </div>
                            <div v-show="subMsgList1.length === 0">
                                <van-empty class="custom-image" :description="$t('300108')">
                                    <svg slot="image" class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-zanwujilu"></use>
                                    </svg>
                                </van-empty>
                            </div>
                        </div>
                        <!-- 奖励规则 -->
                        <div class="awardRule">
                            <div class="awardRule-title">
                                <span>{{$t('9000015')}}</span>
                            </div>
                            <!-- <div class="footerTest1" v-html="subRulerMsg1"></div> -->
                            <p v-html="subRulerMsg1"></p>
                        </div>
                        <!-- 活动规则 -->
                        <div class="activityRule">
                            <div class="activityRule-title">
                                <span>{{$t('300140')}}</span>
                            </div>
                            <!-- <div class="footerTest2" v-html="mainRulerMsg"></div> -->
                            <p v-html="mainRulerMsg"></p>
                        </div>
                    </div>
                    <div class="tables-two" v-if="activeName == 'two'">
                        <!-- 盈利率排名资格赛 table -->
                        <!-- 交易量排名资格赛 table -->
                        <div class="tablesTitle">
                            <div class="tablesTitle-test1">
                                <!-- 盈利率排名赛，解锁最高 <span>{{subNumTwo}}</span> USDT 奖金池 -->
                                <p v-html="$t('9000022', { moneyPond: this.subNumTwo })"></p>
                            </div>
                            <div class="tablesTitle-test2">
                                <!-- 參賽用戶盈利率排名前50名可獲得獎勵，可參考交易排名獎勵規則獲取獎勵 -->
                                {{$t('9000028')}}
                            </div>
                        </div>
                        <div class="tablesPic">
                            <img src="../assets/images/anniversary/yuanMoney.png">
                            <div class="tablesPic-test1">
                                <!-- 奖池金额 -->
                                {{$t('9000011')}}
                                <br>
                                (USDT)
                            </div>
                            <div class="tablesPic-test2">
                                {{subNumTwo}}
                            </div>
                        </div>
                        <div class="rankList">
                            <div class="rankList-title">
                                <span>
                                    <!-- 活动盈利率排名 -->
                                    {{$t('9000018')}}
                                </span>
                            </div>
                            <!--              <div class="rankList-test">
                  &lt;!&ndash; 活动期间每天 8pm(UTC+8)更新 &ndash;&gt;
                  {{$t('9000012')}}
                </div>-->
                            <div class="rankList-pic">
                                <div class="rankListPicMain" v-if="subMsgList2.length > 0">
                                    <div v-if="subMsgList2 && subMsgList2.length >= 1" class="rankOne">
                                        <span>{{subMsgList2[0].userId}}</span>
                                        <!-- <span>linebacker</span> -->
                                    </div>
                                    <div v-if="subMsgList2 && subMsgList2.length >= 2" class="rankTwo">
                                        <span>{{subMsgList2[1].userId}}</span>
                                        <!-- <span>linebacker</span> -->
                                    </div>
                                    <div v-if="subMsgList2 && subMsgList2.length >= 3" class="rankThree">
                                        <span>{{subMsgList2[2].userId}}</span>
                                        <!-- <span>linebacker</span> -->
                                    </div>
                                    <img v-if="!isDirection" src="../assets/images/rankBg.png">
                                    <img v-else src="../assets/images/rankBgFa.png">
                                    <div class="moneyOne">
                                        <!-- 9000013 -->
                                        <!-- 预估奖励 -->
                                        <span>{{$t('9000013')}}(USDT)</span>
                                        <span v-if="subMsgList2[0]">{{subMsgList2[0].rewardEstimate.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                    </div>
                                    <div class="moneyTwo">
                                        <span>{{$t('9000013')}}(USDT)</span>
                                        <span v-if="subMsgList2[1]">{{subMsgList2[1].rewardEstimate.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                    </div>
                                    <div class="moneyThree">
                                        <span>{{$t('9000013')}}(USDT)</span>
                                        <span v-if="subMsgList2[2]">{{subMsgList2[2].rewardEstimate.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="rankList-list" v-show="subMsgList2.length !== 0">
                                <div class="rankList-list-titleBg">
                                    <div>
                                        <span class="titleBg1">{{$t('300084')}}</span>
                                    </div>
                                    <div>
                                        <span class="titleBg2">UID</span>
                                    </div>
                                    <div>
                                        <!-- 累计合約盈利率 -->
                                        <span class="titleBg3">{{$t('9000024')}}</span>
                                    </div>
                                    <div>
                                        <span class="titleBg4">{{$t('9000013')}}</span>
                                    </div>
                                </div>
                            </div>
                            <!-- 循环 -->
                            <div class="rankScrollbar">
                                <div class="rankList-listMain" v-for="item in subMsgList2" :key="item.index">
                                    <div class="listMainIcon">
                                        <div class="listMainIcon-img" :style="{ 'background-image': getBackgroundImage(item.ranked) }">
                                            <span>{{item.ranked}}</span>
                                        </div>
                                    </div>
                                    <div class="listMainTest1">
                                        <span>{{item.userId}}</span>
                                    </div>
                                    <div class="listMainTest2">
                                        <span>{{item.tradeProfit}} %</span>
                                    </div>
                                    <div class="listMainTest3">
                                        <span>{{item.rewardEstimate.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} USDT</span>
                                    </div>
                                </div>
                            </div>
                            <div v-show="subMsgList2.length === 0">
                                <van-empty class="custom-image" :description="$t('300108')">
                                    <svg slot="image" class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-zanwujilu"></use>
                                    </svg>
                                </van-empty>
                            </div>
                        </div>
                        <!-- 奖励规则 -->
                        <div class="awardRule">
                            <div class="awardRule-title">
                                <span>{{$t('9000015')}}</span>
                            </div>
                            <!-- <div class="footerTest1" v-html="subRulerMsg2"></div> -->
                            <p v-html="subRulerMsg2"></p>
                        </div>
                        <!-- 活动规则 -->
                        <div class="activityRule">
                            <div class="activityRule-title">
                                <span>{{$t('300140')}}</span>
                            </div>
                            <!-- <div class="footerTest2" v-html="mainRulerMsg"></div> -->
                            <p v-html="mainRulerMsg"></p>
                        </div>
                    </div>
                    <div class="tables-three" v-if="activeName == 'three'">
                        <!-- 盈利额排名资格赛 table -->
                        <!-- 交易量排名资格赛 table -->
                        <div class="tablesTitle">
                            <div class="tablesTitle-test1">
                                <!-- 交易量排名赛，解锁最高 <span>{{subNumThree}}</span> USDT 奖金池 -->
                                <p v-html="$t('9000023', { moneyPond: this.subNumThree })"></p>
                            </div>
                            <div class="tablesTitle-test2">
                                <!-- 參賽用戶盈利額排名前50名獲得獎勵，可參考交易排名獎勵規則獲取贈金獎勵 -->
                                {{$t('9000027')}}
                            </div>
                        </div>
                        <div class="tablesPic">
                            <img src="../assets/images/anniversary/yuanMoney.png">
                            <div class="tablesPic-test1">
                                <!-- 奖池金额 -->
                                {{$t('9000011')}}
                                <br>
                                (USDT)
                            </div>
                            <div class="tablesPic-test2">
                                {{subNumThree}}
                            </div>
                        </div>
                        <div class="rankList">
                            <div class="rankList-title">
                                <span>
                                    <!-- 活动盈利额排名 -->
                                    {{$t('9000020')}}
                                </span>
                            </div>
                            <!--              <div class="rankList-test">
                  &lt;!&ndash; 活动期间每天 8pm(UTC+8)更新 &ndash;&gt;
                  {{$t('9000012')}}
                </div>-->
                            <div class="rankList-pic">
                                <div class="rankListPicMain" v-if="subMsgList3.length > 0">
                                    <div v-if="subMsgList3 && subMsgList3.length >= 1" class="rankOne">
                                        <span>{{subMsgList3[0].userId}}</span>
                                        <!-- <span>linebacker</span> -->
                                    </div>
                                    <div v-if="subMsgList3 && subMsgList3.length >= 2" class="rankTwo">
                                        <span>{{subMsgList3[1].userId}}</span>
                                        <!-- <span>linebacker</span> -->
                                    </div>
                                    <div v-if="subMsgList3 && subMsgList3.length >= 3" class="rankThree">
                                        <span>{{subMsgList3[2].userId}}</span>
                                        <!-- <span>linebacker</span> -->
                                    </div>
                                    <img v-if="!isDirection" src="../assets/images/rankBg.png">
                                    <img v-else src="../assets/images/rankBgFa.png">
                                    <div class="moneyOne">
                                        <span>{{$t('9000013')}}(USDT)</span>
                                        <span v-if="subMsgList3[0]">{{subMsgList3[0].rewardEstimate.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                    </div>
                                    <div class="moneyTwo">
                                        <span>{{$t('9000013')}}(USDT)</span>
                                        <span v-if="subMsgList3[1]">{{subMsgList3[1].rewardEstimate.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                    </div>
                                    <div class="moneyThree">
                                        <span>{{$t('9000013')}}(USDT)</span>
                                        <span v-if="subMsgList3[2]">{{subMsgList3[2].rewardEstimate.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="rankList-list" v-show="subMsgList3.length !== 0">
                                <div class="rankList-list-titleBg">
                                    <div>
                                        <span class="titleBg1">{{$t('300084')}}</span>
                                    </div>
                                    <div>
                                        <span class="titleBg2">UID</span>
                                    </div>
                                    <div>
                                        <!-- 累计合约盈利额 -->
                                        <span class="titleBg3">{{$t('9000025')}}</span>
                                    </div>
                                    <div>
                                        <span class="titleBg4">{{$t('9000013')}}</span>
                                    </div>
                                </div>
                            </div>
                            <!-- 循环 -->
                            <div class="rankScrollbar">
                                <div class="rankList-listMain" v-for="item in subMsgList3" :key="item.index">
                                    <div class="listMainIcon">
                                        <div class="listMainIcon-img" :style="{ 'background-image': getBackgroundImage(item.ranked) }">
                                            <span>{{item.ranked}}</span>
                                        </div>
                                    </div>
                                    <div class="listMainTest1">
                                        <span>{{item.userId}}</span>
                                    </div>
                                    <div class="listMainTest2">
                                        <span>{{item.tradeProfit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} USDT</span>
                                    </div>
                                    <div class="listMainTest3">
                                        <span>{{item.rewardEstimate.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} USDT</span>
                                    </div>
                                </div>
                            </div>
                            <div v-show="subMsgList3.length === 0">
                                <van-empty class="custom-image" :description="$t('300108')">
                                    <svg slot="image" class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-zanwujilu"></use>
                                    </svg>
                                </van-empty>
                            </div>
                        </div>
                        <!-- 奖励规则 -->
                        <div class="awardRule">
                            <div class="awardRule-title">
                                <span>{{$t('9000015')}}</span>
                            </div>
                            <!-- <div class="footerTest1" v-html="subRulerMsg3"></div> -->
                            <p v-html="subRulerMsg3"></p>
                        </div>
                        <!-- 活动规则 -->
                        <div class="activityRule">
                            <div class="activityRule-title">
                                <span>{{$t('300140')}}</span>
                            </div>
                            <!-- <div class="footerTest2" v-html="mainRulerMsg"></div> -->
                            <p v-html="mainRulerMsg"></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class='purchase-toast' v-if='buySuccess'>
                <!-- <lottie class='lottie' :options='shopMessage.status==1&&num==1?defaultOptions:towOptions'></lottie> -->
                <lottie class="lottie" :options="defaultOptions"></lottie>
                <!-- 300355 报名成功 -->
                <p class='bold'>{{$t('300355')}}</p>
            </div>
            <div class='purchase-toast' v-if='buySuccessShare'>
                <!-- <lottie class='lottie' :options='shopMessage.status==1&&num==1?defaultOptions:towOptions'></lottie> -->
                <!-- <lottie class="lottie" :options="defaultOptions"></lottie> -->
                <!-- 300027 复制成功 -->
                <p class='boldShare'>{{$t('300027')}}</p>
            </div>
        </div>
    </div>
</template>
  <script>
import { mapGetters } from 'vuex'
import { Empty } from 'vant'
import {
    activityMsg,
    mainActivity,
    subActivity,
    application,
    mainRuler,
    subRuler,
    whetherApplication,
} from '@/api/ChristmasActivities.js'
import christmasCountDown from '@/compontents/christmasCountDown.vue'
import { getBanner } from '../api/resource'
import { setToken } from '../utils/auth'
import { getLanguageList } from '../api/user'
import onceBuy from '../../static/animationData/one.json'
import { copy } from 'fastjs-next'
import InCompleteSiteHead from '../compontents/newHome/InCompleteSiteHead.vue'

import '@/assets/newCss/reset.scss'
import '@/assets/tailwendcss.css'
import '@/assets/uemo-icon-font/fonts/ueicon.css'
import '@/assets/newCss/var.scss'
//TODO:行高问题
import '@/assets/newCss/base.scss'

export default {
    name: 'anniversaryActivity',
    components: { christmasCountDown, vanEmpty: Empty, InCompleteSiteHead },
    data() {
        return {
            spreadDropList: [],
            formData: {
                name: '',
                spreadTypeId: '',
                remark: '',
            },
            textVar: this.$t('9000019'), //报名
            changeApplication: 'canApplication',
            resultObj: {},
            mainRes: [],
            progressWidth: 0,
            progress: 0,

            duration: '0s', //进度条遮罩层动画持续时间
            playGuys: '', //参赛人数
            moneyPond: '', //解锁奖池
            xPosition: '',
            activeName: 'one',
            subIdOne: '',
            subIdTwo: '',
            subIdThree: '',
            //子活动 2 3 的奖池
            subNumTwo: '',
            subNumThree: '',
            //子活动三个列表
            subMsgList1: [],
            subMsgList2: [],
            subMsgList3: [],
            //子活动三个规则
            subRulerMsg1: '',
            subRulerMsg2: '',
            subRulerMsg3: '',
            currentPage: 1,
            isLoading: true,
            mainRulerMsg: '',
            fireImageRelativeY: '',
            mathGuys: '',
            allHeight: '',
            cftj: false,
            buySuccess: false,
            buySuccessShare: false,
            defaultOptions: { animationData: onceBuy, loop: false },
            linkType: '',
        }
    },
    created() {
        this.getBanner()
        console.log(this.$route.query, 'this.$route.query')
        if (this.$route.query.backgroundColor != '') {
            window.document.documentElement.setAttribute(
                'data-theme',
                this.$route.query.backgroundColor === 'day'
                    ? 'sunlight'
                    : 'moon'
            )
        }
        window.document.documentElement.setAttribute(
            'dir',
            this.isDirection ? 'rtl' : 'ltr'
        )
        let token = this.$route.query.token || this.token
        let langugage = this.$route.query.language || this.language
        this.$store.dispatch('setLanguage', langugage)
        getLanguageList().then((res) => {
            let el = res.data.find((item) => {
                return item.language == this.$route.query.language
            })
            // this.$store.dispatch('setLanguageName', el.name)
            if (this.$route.query.isApp == 1) {
                this.$i18n.locale = this.$route.query.language
            }
            this.$store.dispatch(
                'setIsDirection',
                this.$route.query.language == 'fa' || this.language == 'fa'
                    ? true
                    : false
            )
            window.document.documentElement.setAttribute(
                'dir',
                this.isDirection ? 'rtl' : 'ltr'
            )
        })
        if (token) {
            setToken(token)
            this.$store.dispatch('GetInfo', token)
            this.$store.dispatch('setToken', token)
        }
        this.getActivityMsg()
        console.log(token, '缓存======token')
        console.log(
            this.$route.query.play$isBanner,
            'this.$router.query.play$isBanner----'
        )
    },
    mounted() {
        this.timer = setInterval(() => {
            this.getRect()
        }, 10)
        setTimeout(() => {
            clearInterval(this.timer)
        }, 10000)
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
    // mounted() {
    //     this.observeFireImage();
    //     this.$nextTick(() => {
    //         const container = this.$el.querySelector('.rankList-listMain');
    //         container.addEventListener('scroll', this.handleScroll);
    //     });
    // },
    // beforeDestroy() {
    //     const container = this.$el.querySelector('.rankList-listMain');
    //     if (container) {
    //         container.removeEventListener('scroll', this.handleScroll);
    //     }
    // },
    computed: {
        ...mapGetters([
            'token',
            'styleType',
            'isDirection',
            'languageName',
            'language',
            'isApp',
        ]),
        count() {
            return this.playGuys
        },
    },
    watch: {
        count(newVal, oldVal) {
            setTimeout(() => {
                this.progressWidth = Math.min(this.count, 1600) / 16 + '%'
                this.progress = Math.min(this.count, 1600) / 16

                this.duration = this.count * 10 + 's'
            }, 0)
        },
        progressWidth(newValue, oldValue) {
            console.log('progressWidth 发生变化')
            this.calculateRelativeY()
        },
    },
    methods: {
        getBanner() {
            getBanner({ type: 2 })
                .then((res) => {
                    if (res.code === 200) {
                        this.bannerList = res.data
                        console.log(this.bannerList, 'bannerList==========')
                        const anniversaryBanner = res.data.find((item) =>
                            item.link.includes('/anniversaryActivity')
                        )
                        if (anniversaryBanner) {
                            this.linkType = anniversaryBanner.linkType
                            console.log(this.linkType, 'this.linkType')
                        }
                    }
                })
                .catch(() => {
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        appLogin() {
            let banner = this.$route.query.banner ? '&banner=1' : ''
            if (this.$route.query.isApp == 1 || this.isApp == 1) {
                this.$jsBridge.callHandler(
                    this.$jsBridgeCmd.appLogin,
                    {
                        code: 200,
                        type: 'login',
                        url:
                            window.location.href.toString().split('?')[0] +
                            `?id=${this.$route.query.id}${banner}`,
                    },
                    (data) => {}
                )
            } else {
                this.$router.push({
                    path: '/login',
                    query: {
                        historyBack: `/anniversaryActivity`,
                    },
                })
            }
        },
        /*appLogin() {
          let banner = this.$route.query.banner ? '&banner=1' : ''
          if (this.$route.query.isApp == 1 || this.isApp == 1) {
              this.$jsBridge.callHandler(
                  this.$jsBridgeCmd.appLogin,
                  {
                      code: 200,
                      type: 'login',
                      // url:
                      //     window.location.href.toString().split('?')[0] +
                      //     `?id=${this.$route.query.id}&language=${this.$route.query.language}${banner}`,
                  },
                  (data) => {}
              )
          } else {
              this.$router.push({
                  path: '/login',
                  query: {
                      historyBack: `/contractCompetition?id=${this.$route.query.id}`,
                  },
              })
          }
      },*/
        goBackApp() {
            this.$jsBridge.callHandler(
                this.$jsBridgeCmd.goBack,
                {},
                (data) => {}
            )
        },
        goBack() {
            if (this.$route.query.isBanner == 0) {
                let isApp =
                    this.$route.query.isApp || this.isApp ? '&isApp=1' : ''
                this.$router.push(
                    `/activity?language=${this.language}${isApp}&backgroundColor=` +
                        this.$route.query.backgroundColor
                )
            } else {
                this.goBackApp()
            }
        },
        getRect() {
            this.$nextTick(() => {
                this.fireImageRect =
                    this.$refs.fireImage.getBoundingClientRect()
                this.barRowRect = this.$refs.barRow.getBoundingClientRect()
                this.calculateRelativeY()
            })
        },
        calculateRelativeY() {
            // console.log( this.fireImageRect,'this.fireImageRect.top' )
            // console.log( this.barRowRect,' this.barRowRect.top')
            this.allHeight = this.$refs.barRow.offsetHeight
            this.fireImageRelativeY =
                this.fireImageRect.top -
                this.barRowRect.top +
                this.allHeight * (7 / 180)
            //   this.fireImageRelativeY =
            // this.fireImageRect.top

            // console.log(this.allHeight, '----allHeight---') //j进度条的总高
            // console.log(
            //     'fireImage相对于barRow的Y轴坐标：',
            //     this.fireImageRelativeY
            // )
        },

        // proY   z=换成比例的
        getImage(fireImageRelativeY, proY) {
            let heightArr = [100, 500, 1000, 1500]
            if (heightArr.includes(this.playGuys)) {
                fireImageRelativeY = fireImageRelativeY + 1
            }
            // console.log(fireImageRelativeY, 'fireImageRelativeY')
            // console.log(
            //     this.allHeight * (proY / 100),
            //     ' this.allHeight * (proY / 100)'
            // )
            if (fireImageRelativeY >= this.allHeight * (proY / 100)) {
                return require('@/assets/images/yuanyuanCH.png')
            } else {
                return require('@/assets/images/blackIcon.png')
            }
            //    if (this.progress / 100 >= (proY / 100)) {
            //     return require('@/assets/images/yuanyuanCH.png')
            // } else {
            //     return require('@/assets/images/blackIcon.png')
            // }
        },
        goApplication() {
            console.log(this.$route.query.token, 'this.$route.query.token')
            console.log(this.token, 'this.token')
            if (this.cftj) return
            this.cftj = true
            if (this.changeApplication === 'noCanApplication') {
                return
            } else if (this.$route.query.token || this.token) {
                // this.$router.push(
                //     '/login?historyBack=' +
                //         window.encodeURIComponent('/events/ChristmasActivities')
                // )
                console.log('是登录状态')
                application(this.resultObj.id)
                    .then((res) => {
                        console.log(res, '看看报名后的res')
                        // this.$notify({
                        //     message: '报名成功',
                        //     iconClass: 'iconfont icon-wancheng-2',
                        //     customClass: 'successIcon flex-center',
                        //     showClose: false,
                        //     duration: 2000,
                        //     position: this.IsShow() ? 'top-left' : 'top-right',
                        // })
                        this.textVar = this.$t('300353') //已报名
                        this.changeApplication = 'noCanApplication'
                        this.buySuccess = true
                        let timer = setTimeout(() => {
                            this.buySuccess = false
                            clearTimeout(timer)
                        }, 2000)
                    })
                    .finally(() => {
                        this.cftj = false
                    })
            } else {
                console.log('不是登录状态，看看调没调appLogin')
                this.appLogin()
            }
        },
        goShareUrl() {
            console.log('点击了分享')
            if (this.$route.query.isApp == 1 || this.isApp == 1) {
                this.$jsBridge.callHandler(
                    this.$jsBridgeCmd.appSharing,
                    {
                        code: 200,
                        // img: this.shopMessage.imgs[0],
                        title: this.$t('300333'),
                        url: window.location.href.split('?')[0],
                        text: '',
                    },
                    (data) => {}
                )
            } else {
                copy(window.location.href)
                this.buySuccessShare = true
                let timer = setTimeout(() => {
                    this.buySuccessShare = false
                    clearTimeout(timer)
                }, 2000)
            }
        },
        getBackgroundImage(ranked) {
            // console.log(ranked, '看看ranked');
            let backgroundImage = ''
            switch (ranked) {
                case 1:
                    backgroundImage = `url(${require('../assets/images/rankOneIcon.png')})`
                    break
                case 2:
                    backgroundImage = `url(${require('../assets/images/rankTwoIcon.png')})`
                    break
                case 3:
                    backgroundImage = `url(${require('../assets/images/rankThreeIcon.png')})`
                    break
                default:
                    backgroundImage = `url(${require('../assets/images/rankOtherIcon.png')})`
            }
            return backgroundImage
        },
        tabChange(val, id) {
            // console.log(val)
            console.log(id, '看看subid')
            this.activeName = val
            console.log(this.activeName)
            this.getSubActivity(val)
            this.getSubRuler(val)
        },
        setStart() {
            let timer = null
            let isGet = false
            timer = setInterval(() => {
                this.currentTimeStamp = Date.now()
                // console.log(
                //     this.currentTimeStamp,
                //     '当前的时间戳currentTimeStamp'
                // )
                if (this.currentTimeStamp < this.resultObj.startTime) {
                    console.log('现在是未开始')
                    this.textVar = this.$t('9000026') //未开始
                    this.changeApplication = 'noCanApplication'
                } else if (
                    this.currentTimeStamp > this.resultObj.startTime &&
                    this.currentTimeStamp < this.resultObj.endTime
                ) {
                    console.log('开始了')
                    // this.textVar = this.$t('9000019') //报名
                    // this.changeApplication = 'canApplication'
                    if (!isGet) {
                        this.textVar = this.$t('9000019') //报名
                        this.changeApplication = 'canApplication'
                    }
                    if (this.token && !isGet) {
                        whetherApplication(this.resultObj.id).then((res) => {
                            console.log(res, '看看是否报名的状态')
                            if (res.data == false) {
                                this.textVar = this.$t('9000019') //报名
                                this.changeApplication = 'canApplication'
                            } else {
                                this.textVar = this.$t('300353') //已报名
                                this.changeApplication = 'noCanApplication'
                            }
                        })
                    }
                    isGet = true
                } else if (this.currentTimeStamp > this.resultObj.endTime) {
                    console.log('现在是已结束')
                    this.textVar = this.$t('9000021') //已结束
                    this.changeApplication = 'noCanApplication'
                    clearInterval(timer)
                }
            }, 1000)
        },
        getActivityMsg() {
            // this.loading = true
            activityMsg().then((res) => {
                this.resultObj = res.data
                this.mainId = res.data.id
                console.log(this.resultObj, '看看主活动的msg')

                this.setStart()

                this.getMainActivity()
                this.getMainRuler()
                // setTimeout(()=>{
                //     this.loading = false
                // },1500)
            })
            // .finally(() => {
            //     this.loading = false
            // })
        },
        getMainActivity() {
            mainActivity(this.resultObj.id).then((res) => {
                this.mainRes = res.data
                console.log(this.mainRes, 'mainRes')
                this.playGuys = this.mainRes.reduce(
                    (result, item) =>
                        result + (item.type === 1 ? item.number : ''),
                    ''
                )
                //看下已解锁奖池
                if (this.playGuys < 100) {
                    this.moneyPond = '--'
                } else if (this.playGuys >= 100 && this.playGuys < 500) {
                    this.moneyPond = '2,500'
                } else if (this.playGuys >= 500 && this.playGuys < 1000) {
                    this.moneyPond = '5,000'
                } else if (this.playGuys >= 1000 && this.playGuys < 1500) {
                    this.moneyPond = '7,500'
                } else if (this.playGuys >= 1500) {
                    this.moneyPond = '10,000'
                }

                // 子活动 1 的id
                let subIdOneArray = this.mainRes
                    .filter((item) => item.type === 1)
                    .map((item) => item.id)
                this.subIdOne = subIdOneArray[0]
                // 子活动 2 的id
                let subIdTwoArray = this.mainRes
                    .filter((item) => item.type === 2)
                    .map((item) => item.id)
                this.subIdTwo = subIdTwoArray[0]
                // 子活动 3 的id
                let subIdThreeArray = this.mainRes
                    .filter((item) => item.type === 3)
                    .map((item) => item.id)
                this.subIdThree = subIdThreeArray[0]
                console.log(this.subIdOne, 'subIdOne---')
                console.log(this.subIdTwo, 'subIdOne---')
                console.log(this.subIdThree, 'subIdThree---')

                // 子活动 2 的num
                let subNumTwoArray = this.mainRes
                    .filter((item) => item.type === 2)
                    .map((item) => item.number)
                this.subNumTwo = subNumTwoArray[0]
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                // 子活动 3 的num
                let subNumThreeArray = this.mainRes
                    .filter((item) => item.type === 3)
                    .map((item) => item.number)
                this.subNumThree = subNumThreeArray[0]
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                console.log(this.subNumTwo, 'subNumTwo---')
                console.log(this.subNumThree, 'subNumThree---')

                console.log(this.playGuys) // 输出过滤后的 number 值字符串

                if (this.playGuys < 100 && this.playGuys != 0) {
                    this.mathGuys = this.playGuys
                } else if (this.playGuys == 0) {
                    this.mathGuys = '--'
                } else {
                    this.mathGuys = Math.floor(this.playGuys / 100) * 100 + '+'
                }

                this.getSubActivity('one')
                this.getSubRuler('one')
            })
        },
        getSubActivity(val) {
            console.log(val, '看看接口里面的val')
            let changeId
            if (val == 'one') {
                changeId = this.subIdOne
            } else if (val == 'two') {
                changeId = this.subIdTwo
            } else if (val == 'three') {
                changeId = this.subIdThree
            }
            let data = {
                rankSubId: changeId,
                page: 1,
                pageSize: 999,
                sort: 'id',
                order: 'asc',
            }
            subActivity(data).then((res) => {
                console.log(res.data.items, 'res.data.items---子活动数据')
                if (val == 'one') {
                    this.subMsgList1 = res.data.items
                } else if (val == 'two') {
                    this.subMsgList2 = res.data.items
                } else if (val == 'three') {
                    this.subMsgList3 = res.data.items
                }
            })
        },
        getSubRuler(val) {
            let changeSubId
            if (val == 'one') {
                changeSubId = this.subIdOne
            } else if (val == 'two') {
                changeSubId = this.subIdTwo
            } else if (val == 'three') {
                changeSubId = this.subIdThree
            }
            console.log(val, '看看val')
            console.log(changeSubId, '看看changeSubId')
            subRuler(changeSubId).then((res) => {
                console.log(res, '看看对应子活动的规则')
                if (val == 'one') {
                    this.subRulerMsg1 = res.data
                } else if (val == 'two') {
                    this.subRulerMsg2 = res.data
                } else if (val == 'three') {
                    this.subRulerMsg3 = res.data
                }
            })
        },
        //主活动规则
        getMainRuler() {
            mainRuler(this.resultObj.id).then((res) => {
                this.mainRulerMsg = res.data
            })
        },
        formatTimestamp(timestamp) {
            const date = new Date(timestamp)
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            const seconds = String(date.getSeconds()).padStart(2, '0')

            return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`
        },
    },
}
</script>
  <style lang="scss" scoped>
@import '../assets/css/variableName';
@import '../style/mixin';
//zc
[dir='ltr'] {
    .proMain {
        margin-left: torem(20);
    }
    .activeTab::after {
        left: 32%;
        right: 0;
    }
    .titleBg1,
    .titleBg2,
    .titleBg3 {
        margin-left: torem(6);
    }
    .titleBg4 {
        margin-right: torem(6);
    }
    .leveIcon {
        margin-left: torem(-4);
    }
    .fireImage {
        margin-left: torem(-4);
    }
    .listMainIcon-img {
        margin-left: torem(6);
    }
    .listMainTest1 span {
        margin-left: torem(6);
    }
    .listMainTest2 span {
        margin-left: torem(6);
    }
    .listMainTest3 span {
        margin-left: torem(6);
    }
    .chGuys {
        margin-left: torem(4);
    }
}
[dir='rtl'] {
    .proMain {
        margin-right: torem(20);
    }
    .activeTab::after {
        left: 0;
        right: 32%;
    }
    .titleBg1,
    .titleBg2,
    .titleBg3 {
        margin-right: torem(6);
    }
    .titleBg4 {
        margin-left: torem(6);
    }
    .leveIcon {
        margin-right: torem(-4);
    }
    .fireImage {
        margin-right: torem(-4);
    }
    .listMainIcon-img {
        margin-right: torem(6);
    }
    .listMainTest1 span {
        margin-right: torem(6);
    }
    .listMainTest2 span {
        margin-right: torem(6);
    }
    .listMainTest3 span {
        margin-right: torem(6);
    }
    .chGuys {
        margin-right: torem(4);
    }
}
</style>
  <style lang="scss" scoped>
@import '../assets/css/variableName';
@import '../style/mixin';
@import '../assets/css/mixin';
.content {
    // position: fixed !important;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    overflow: hidden;
    // padding: 0 torem(16) torem(45) torem(16);
    background-color: #0e0803;
    // height: torem(2500);
    // height: 100vh;
    // padding-bottom: torem(45);
    .bg {
        width: 100%;
        // height: torem(540);
        background-image: url('../assets/images/anniversary/h5Bg.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% 100%;
        padding-left: torem(16);
        padding-right: torem(16);
        // padding-top: torem(44);
        .h5Title {
            // display: flex;
            // justify-content: center;
            width: torem(320);
            height: torem(490);
            // border: 1px solid red;
            margin: 0 auto;
            background-image: url('../assets/images/anniversary/tree@3x.png');
            background-repeat: no-repeat;
            background-position: center;
            background-size: 100% 100%;

            // TODO
            margin-top: torem(49);
            .titleHeight {
                height: torem(39);
            }
            .title {
                display: flex;
                justify-content: center;
                width: torem(203);
                height: torem(62);
                background-image: url('../assets/images/anniversary/title@3x.png');
                background-repeat: no-repeat;
                background-position: center;
                background-size: 100% 100%;
                margin: 0 auto;
                // z-index: 999;
                span {
                    height: 48px;
                    line-height: 48px;
                    font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                    color: #ffffff;
                    font-size: torem(14);
                    font-weight: 800;
                    margin-top: 72px;
                    text-shadow: 2px 1px 0px #501700;
                }
            }
            .titleTest {
                display: flex;
                height: torem(120);
                justify-content: center;
                margin-top: torem(25);
                margin-bottom: torem(200);
                font-size: torem(20);
                z-index: 1;
                &-test {
                    width: 100%;
                    p {
                        text-align: center;
                        color: #ffffff;
                        font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                        font-weight: 800;
                        line-height: 1.2;
                    }
                    &-p2 {
                        margin-top: torem(8);
                    }
                }
            }
            .buttonModule {
                position: relative;
                width: torem(298);
                // top: torem(10);
                z-index: 1;
                // width: 480px;
                margin: 0 auto;
                &-buttons {
                    display: flex;
                    justify-content: space-between;
                    div {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: torem(145);
                        height: torem(44);
                        padding: torem(16) 0;
                        font-size: torem(16);
                        border-radius: 4px 4px 4px 4px;
                    }
                    .canApplication {
                        background: linear-gradient(
                            180deg,
                            #f8d753 0%,
                            #fdba06 100%
                        );
                        color: #501700;
                    }
                    .noCanApplication {
                        background: linear-gradient(
                            180deg,
                            #9f9f9f 0%,
                            #494949 100%
                        );
                        color: rgba(255, 255, 255, 0.5);
                    }
                    .share {
                        background: rgba(0, 0, 0, 0.5);
                        backdrop-filter: blur(10px);
                        color: #ffc72b;
                        border: 1px solid #ffc72b;
                    }
                }
            }
            .timeModule {
                width: torem(286);
                margin: 0 auto;
                &-main {
                    display: flex;
                    justify-content: center;
                    margin-top: torem(24);
                    font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                }
                &-time {
                    // margin-top: torem(12);
                    color: rgba(255, 255, 255, 0.7);
                    font-size: torem(10);
                    text-align: center;
                    font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                    font-weight: 400;
                }
            }
        }
    }
    .leekBar {
        // display: flex;
        // justify-content: center;
        width: torem(343);
        height: torem(307);
        margin: 0 auto;
        margin-bottom: 32px;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 24px 24px 24px 24px;
        // backdrop-filter: blur(10px);
        &-main {
            display: flex;
            justify-content: center;
            flex-direction: column;
            margin-top: torem(106);
            position: relative;
            &-guys {
                display: flex;
                // justify-content: space-between;
                align-items: center;
                width: torem(327);
                height: torem(64);
                background: linear-gradient(180deg, #ffe06f 0%, #f1b100 100%);
                border-radius: 8px 8px 8px 8px;
                margin-top: torem(24);
                padding: 0 torem(8);
                .man {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width: torem(151);
                    height: torem(35);
                    text-align: center;
                    font-size: torem(12);
                    font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                    font-weight: 500;
                    color: rgba(80, 23, 0, 0.7);
                    //todo
                    line-height: torem(14);
                    div {
                        &:nth-child(2) {
                            font-size: torem(24);
                            font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                            font-weight: 800;
                            color: #501700;
                        }
                    }
                }
                .line {
                    width: torem(1);
                    height: torem(19);
                    background-color: #501700;
                    margin: 0 torem(4);
                }
                .money {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width: torem(151);
                    height: torem(35);
                    text-align: center;
                    font-size: torem(12);
                    font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                    font-weight: 500;
                    color: rgba(80, 23, 0, 0.7);
                    //todo
                    line-height: torem(14);
                    div {
                        &:nth-child(2) {
                            font-size: torem(24);
                            font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                            font-weight: 800;
                            color: #501700;
                        }
                    }
                }
            }
            &-pro {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: torem(180);
                margin-top: torem(17);
                padding: 0 torem(8);
                .progressBar {
                    // transform: rotate(90deg);

                    width: torem(6);
                    // overflow: hidden;
                    // height: 41px;
                    .barRow {
                        // width: 1036px;
                        // height: 16px;
                        // margin-top: 8.5rem;
                        width: torem(6);
                        height: torem(180);
                        // transform: rotate(90deg);
                        // margin: 7px auto;
                        border-radius: 6px;
                        background: #383a3f;
                        position: relative;
                        display: flex;
                        align-items: center;
                        .leveIcon {
                            // width: 1036px;
                            height: torem(180);
                            // margin-left: torem(-4);
                            z-index: 999;
                            width: torem(6);
                            .blackIcon {
                                width: torem(14);
                                min-width: torem(14);
                                height: torem(14);
                                min-height: torem(14);
                            }
                            margin-right: torem(-4);

                            &-one {
                                margin-top: torem(5);
                            }
                            &-two {
                                margin-top: torem(30);
                            }
                            &-three {
                                margin-top: torem(41.5);
                            }
                            &-four {
                                margin-top: torem(41.8);
                            }
                        }
                        .fireImage {
                            z-index: 999;
                            // margin-bottom: torem(2);
                            // margin-left: torem(-4);
                            margin-top: torem(-7);

                            width: torem(14);
                            min-width: torem(14);
                            height: torem(14);
                            position: absolute;
                            transition: top 3s linear;
                            // bottom: torem(2);
                        }
                        .rate-of-progress {
                            // height: 12px;
                            position: absolute;
                            top: 0;
                            // height: torem(158);
                            width: torem(6);
                            transition: height 3s linear;

                            .progress-img {
                                position: absolute;
                                height: 12px;
                                // width: 100%;
                                top: 0;
                                // left: 0;
                                opacity: 0.5;
                                width: 0;
                                transition: height 3s linear;
                                // background: url('../../assets/images/mask.png')
                                // repeat-x 50%;
                                border-radius: 6px;
                                animation: progress-move 4s linear infinite;
                            }
                            .progress-color {
                                height: 100%;
                                width: torem(6);
                                top: 0;
                                border-radius: 6px;
                                background: linear-gradient(
                                    180deg,
                                    #ffd664 0%,
                                    #e9af0c 100%
                                );
                            }
                        }
                    }
                    .barTest {
                        height: 14px;
                        // line-height: 14px;
                        font-size: 12px;
                        font-weight: 400;
                        color: #7f8490;
                    }
                }
                .proMain {
                    // position: absolute;
                    // flex: 1;
                    // margin-left: torem(20);
                    width: torem(306);
                    height: torem(170);

                    // border: 1px solid red;
                    .top1 {
                        margin-top: torem(31);
                    }
                    .top2 {
                        margin-top: torem(42);
                    }
                    .top3 {
                        margin-top: torem(40);
                    }
                    &-item {
                        display: flex;
                        justify-content: space-between;
                        height: torem(14);
                        line-height: torem(14);
                        color: rgba(255, 255, 255, 0.7);
                        font-size: torem(12);
                        font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                        font-weight: 500;

                        &-money {
                        }
                        &-icon {
                            display: flex;
                            align-items: center;
                            .proMainNums {
                                // height: torem(14);
                                // line-height: torem(14);
                                margin-top: torem(2);
                            }
                        }
                    }
                }
                @keyframes progress-move {
                    0% {
                        // background-position: torem(-60) 0;
                        background-position: -60px 0;
                    }
                }
            }
        }
    }
    .toSwitch {
        width: torem(343);
        margin: 0 auto;
        padding: torem(24) torem(8);
        background: rgba(255, 255, 255, 0.05);
        border-radius: torem(7);
        // backdrop-filter: blur(10px);
        .tabs {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            font-size: torem(12);
            text-align: center;
            font-family: Plus Jakarta Sans, Plus Jakarta Sans;
            font-weight: 800;
            color: #ffffff;
            div {
                display: flex;
                flex-direction: column;
                align-items: center;
                width: torem(98);
                line-height: torem(17);
                // padding-bottom: torem(8);
                // position: relative;
                .borderBottom {
                    display: none;
                    flex-shrink: 0;
                    width: torem(36);
                    height: torem(3);
                    margin-top: torem(5);
                    background: linear-gradient(
                        270deg,
                        rgba(255, 199, 43, 0) 0%,
                        #ffc72b 54%,
                        rgba(255, 199, 43, 0) 100%
                    );
                }
                &.activeTab {
                    .borderBottom {
                        display: block;
                    }
                }
            }
            // ::after {
            //     content: '';
            //     position: absolute;
            //     // left: 32%;
            //     // right: 0;
            //     bottom: 0;
            //     width: torem(36);
            //     height: torem(3);
            //     background: linear-gradient(
            //         270deg,
            //         rgba(255, 199, 43, 0) 0%,
            //         #ffc72b 54%,
            //         rgba(255, 199, 43, 0) 100%
            //     );
            // }
        }
        .tables {
            .tablesTitle {
                margin-top: torem(34);
                padding: 0 torem(14);
                &-test1 {
                    font-size: torem(18);
                    line-height: torem(21);
                    font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                    font-weight: 600;
                    color: #ffffff;
                    text-align: center;
                    span {
                        color: #ffc72b;
                    }
                }
                &-test2 {
                    margin-top: torem(8);
                    margin-bottom: torem(25);
                    font-size: torem(11);
                    font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 0.7);
                    line-height: torem(13);
                    text-align: center;
                }
            }
            .tablesPic {
                // width: torem(220);
                height: torem(154);
                display: flex;
                position: relative;
                justify-content: center;
                // margin-top: torem(25);
                margin: 0 auto;
                background-image: url('../assets/images/anniversary/yuanMoney.png');
                background-repeat: no-repeat;
                background-position: center;
                background-size: 100% 100%;

                &-test1 {
                    // max-width: torem(320);
                    position: absolute;
                    font-size: torem(10);
                    font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                    font-weight: 400;
                    line-height: torem(10);
                    color: rgba(255, 255, 255, 0.7);
                    margin-top: torem(34);
                    text-align: center;
                }
                &-test2 {
                    position: absolute;
                    font-size: torem(24);
                    font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                    font-weight: 800;
                    // text-shadow: 2px 2px 0px #1d1502;
                    // text-shadow: -2px -2px 0px #1d1502;
                    background: linear-gradient(
                        180deg,
                        #ffe46d 0%,
                        #ffc72b 100%
                    );
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    margin-top: torem(59);
                }
            }
            .rankList {
                margin: 0 auto;
                /deep/ .van-empty__image {
                    // min-height: torem(80);
                    height: auto;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    //width:auto ;
                    //min-width: torem(80);
                    svg {
                        width: torem(57);
                        height: torem(57);
                    }
                }
                &-title {
                    max-width: torem(280);
                    margin: 0 auto;
                    margin-top: torem(48);
                    font-size: torem(14);
                    font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                    font-weight: 800;
                    color: #ffffff;
                    text-align: center;
                    position: relative;
                    height: torem(21);
                    line-height: torem(21);
                    span {
                        position: relative;
                        display: block;
                    }
                    span::after {
                        content: '';
                        position: absolute;
                        width: torem(36);
                        // left: 32%;
                        // right: 0;
                        left: 50%;
                        margin-left: torem(-18);
                        bottom: torem(
                            -6
                        ); /* 根据需要调整位置，以便与文本底部对齐 */
                        height: torem(3); /* 边框的厚度 */
                        background: linear-gradient(
                            270deg,
                            rgba(255, 199, 43, 0) 0%,
                            #ffc72b 54%,
                            rgba(255, 199, 43, 0) 100%
                        );
                        display: block; /* 确保伪元素是块级元素 */
                    }
                }
                &-test {
                    margin-top: torem(30);
                    text-align: center;
                    font-size: torem(11);
                    font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 0.7);
                }
                &-pic {
                    display: flex;
                    justify-content: center;
                    margin-top: torem(28);
                    .rankListPicMain {
                        display: flex;
                        justify-content: center;
                        width: torem(322);
                        // height: torem(165);
                        position: relative;
                        padding-top: torem(26);
                        img {
                            width: 100%;
                            height: 100%;
                        }
                        div {
                            position: absolute;
                            font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                            font-weight: 500;
                            color: #ffffff;
                            span {
                                display: block;
                                font-size: torem(10);
                                text-align: center;
                            }
                        }
                        .rankOne {
                            top: torem(7);
                        }
                        .rankTwo {
                            position: absolute;
                            margin-right: torem(188) !important;
                            margin-top: torem(5);
                        }
                        .rankThree {
                            position: absolute;
                            margin-left: torem(188) !important;
                            margin-top: torem(5);
                        }
                        .moneyOne,
                        .moneyTwo,
                        .moneyThree {
                            span {
                                &:nth-child(1) {
                                    font-size: torem(9);
                                    font-family: Plus Jakarta Sans,
                                        Plus Jakarta Sans;
                                    font-weight: 500;
                                    color: rgba(255, 255, 255, 0.7);
                                    line-height: torem(12);
                                }
                                &:nth-child(2) {
                                    font-size: torem(14);
                                    font-family: Plus Jakarta Sans,
                                        Plus Jakarta Sans;
                                    font-weight: 800;
                                    color: #ffffff;
                                    margin-top: torem(4);
                                    line-height: torem(12);
                                }
                            }
                        }
                        .moneyOne {
                            width: torem(66);
                            top: torem(120);
                        }
                        .moneyTwo {
                            width: torem(66);
                            left: torem(35);
                            top: torem(140);
                        }
                        .moneyThree {
                            width: torem(66);
                            right: torem(35);
                            top: torem(140);
                        }
                    }

                    // height: 591px;
                }
                &-list {
                    display: flex;
                    justify-content: center;
                    &-titleBg {
                        width: torem(322);
                        height: torem(44);
                        background: #383a3f;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        div {
                            &:nth-child(1) {
                                width: torem(44);
                            }
                            &:nth-child(2) {
                                width: torem(88);
                            }
                            &:nth-child(3) {
                                width: torem(102);
                                text-align: center;
                            }
                            &:nth-child(4) {
                                width: torem(88);
                                text-align: right;
                            }
                            // span {
                            //     margin-left: torem(6);
                            //     font-size: torem(10);
                            //     font-family: Lato, Lato;
                            //     font-weight: 400;
                            //     color: rgba(255, 255, 255, 0.5);
                            // }
                        }
                        .titleBg1,
                        .titleBg2 {
                            // margin-left: torem(6);
                            font-size: torem(9);
                            font-family: Lato, Lato;
                            font-weight: 400;
                            color: rgba(255, 255, 255, 0.5);
                        }
                        .titleBg3 {
                            // margin-left: torem(6);
                            font-size: torem(9);
                            font-family: Lato, Lato;
                            font-weight: 400;
                            color: rgba(255, 255, 255, 0.5);
                        }
                        .titleBg4 {
                            // margin-right: torem(6);
                            font-size: torem(9);
                            font-family: Lato, Lato;
                            font-weight: 400;
                            color: rgba(255, 255, 255, 0.5);
                        }
                    }
                }
                .rankScrollbar {
                    max-height: torem(440);
                    overflow-y: auto;
                }
                .rankScrollbar::-webkit-scrollbar {
                    // display: none; /* 对于Webkit，隐藏滚动条 */
                    width: torem(2);
                    background-color: #232227;
                }
                .rankScrollbar::-webkit-scrollbar-thumb {
                    background-color: rgba(255, 255, 255, 0.1);
                    border-radius: torem(2);
                }
                &-listMain {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    // width: 1136px;
                    width: torem(322);
                    height: torem(44);
                    border-bottom: torem(1) solid rgba(255, 255, 255, 0.1);
                    div {
                        width: 264px;
                    }
                    .listMainIcon {
                        width: torem(44);
                        &-img {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            width: torem(20);
                            height: torem(16);
                            // margin-left: torem(6);
                            // background-image: url('../assets/images/rankOneIcon.png');
                            background-size: cover;
                            span {
                                font-size: torem(7);
                                font-family: Plus Jakarta Sans,
                                    Plus Jakarta Sans;
                                font-weight: 800;
                                color: #ffffff;
                            }
                        }
                    }
                    .listMainTest1 {
                        width: torem(88);
                        font-size: torem(12);
                        font-family: Lato, Lato;
                        font-weight: 400;
                        color: #ffffff;
                        span {
                            margin-left: torem(6);
                        }
                    }
                    .listMainTest2 {
                        width: torem(102);
                        font-size: torem(12);
                        font-family: Lato, Lato;
                        font-weight: 400;
                        color: #ffffff;
                        span {
                            margin-left: torem(6);
                        }
                    }
                    .listMainTest3 {
                        width: torem(88);
                        font-size: torem(12);
                        font-family: Lato, Lato;
                        font-weight: 400;
                        color: #ffffff;
                        text-align: right;
                        span {
                            margin-right: torem(6);
                        }
                    }
                }
            }
            .awardRule {
                &-title {
                    max-width: torem(280);
                    margin: 0 auto;
                    margin-top: torem(35);
                    font-size: torem(16);
                    height: torem(24);
                    line-height: torem(24);
                    font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                    font-weight: 800;
                    color: #ffffff;
                    text-align: center;
                    position: relative;
                    span {
                        position: relative;
                    }
                    span::after {
                        content: '';
                        width: torem(36);
                        position: absolute;
                        // left: 35%;
                        // right: 0;
                        left: 50%;
                        margin-left: torem(-18);
                        bottom: torem(
                            -6
                        ); /* 根据需要调整位置，以便与文本底部对齐 */
                        height: torem(3); /* 边框的厚度 */
                        background: linear-gradient(
                            270deg,
                            rgba(255, 199, 43, 0) 0%,
                            #ffc72b 54%,
                            rgba(255, 199, 43, 0) 100%
                        );
                        display: block; /* 确保伪元素是块级元素 */
                    }
                }
                p {
                    margin-top: torem(24);
                    margin-bottom: torem(34);
                    line-height: torem(15);
                    // font-size: 16px;
                    // font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                    // font-weight: 400;
                    // color: rgba(255, 255, 255, 0.7);
                }
                // .footerTest1 {
                //     margin-top: torem(24);
                //     margin-bottom: torem(34);
                //     line-height: torem(13);
                // }
            }
            .activityRule {
                &-title {
                    max-width: torem(280);
                    margin: 0 auto;
                    font-size: torem(16);
                    font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                    font-weight: 800;
                    color: #ffffff;
                    text-align: center;
                    position: relative;
                    span {
                        position: relative;
                    }
                    span::after {
                        content: '';
                        width: torem(36);
                        position: absolute;
                        // left: 35%;
                        // right: 0;
                        left: 50%;
                        margin-left: torem(-18);
                        bottom: torem(
                            -6
                        ); /* 根据需要调整位置，以便与文本底部对齐 */
                        height: torem(3); /* 边框的厚度 */
                        background: linear-gradient(
                            270deg,
                            rgba(255, 199, 43, 0) 0%,
                            #ffc72b 54%,
                            rgba(255, 199, 43, 0) 100%
                        );
                        display: block; /* 确保伪元素是块级元素 */
                    }
                }
                p {
                    margin-top: torem(24);
                    line-height: torem(15);
                    // font-size: 16px;
                    // font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                    // font-weight: 400;
                    // color: rgba(255, 255, 255, 0.7);
                }
                // .footerTest2 {
                //     margin-top: torem(24);
                //     line-height: torem(13);
                // }
            }
        }
    }
}
.newBg {
    // padding-top: 2.2rem;
    flex: 1;
    // height: 100vh;
    // overflow-y: auto;
    overflow: auto;
}
.chGuys {
    width: torem(16);
    height: torem(16);
    // margin-left: torem(4);
}
.contract-header {
    padding: 0 torem(16);
    width: 100%;
    box-sizing: border-box;
    height: torem(44);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: fixed;
    top: 0;
    @include background_color('background-color-2');
    //background: #fff;
    left: 0;
    z-index: 9999;
    i {
        font-size: torem(18);
        width: torem(14);
        height: torem(18);
        @include font_color('font-color');
        display: inline-block;
        //color: rgba(255, 255, 255, 1);
    }
}

.purchase-toast {
    padding: torem(8) 0 torem(42) 0;
    box-sizing: border-box;
    p {
        color: #fff;
        font-size: torem(16);
        line-height: torem(18);
        margin-top: torem(14);
        width: 100%;
        text-align: center;
    }
    > div {
        width: torem(60) !important;
        height: torem(60) !important;
    }
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 9999;
    transform: translate(-50%, -50%);
    width: torem(197);
    height: torem(143);
    border-radius: torem(8);
    background: rgba($color: #000000, $alpha: 0.8);
    .boldShare {
        margin-top: torem(50);
    }
}
</style>
  


// WEBPACK FOOTER //
// src/view/anniversaryActivity.vue